/**
 * FooterDetails
 * Handles opening/closing details elements based on viewport size
 */
class FooterDetails {
  constructor() {
    this.detailsElements = document.querySelectorAll('.footer-main__nav-item');
    this.breakpoint = 768; // md breakpoint
    
    if (this.detailsElements.length === 0) return;
    
    this.init();
  }

  init() {
    // Set initial state
    this.handleResize();

    // Handle window resize with debounce
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.handleResize(), 150);
    });
  }

  handleResize() {
    const isDesktop = window.innerWidth >= this.breakpoint;

    this.detailsElements.forEach(details => {
      if (isDesktop) {
        // Open on desktop
        details.setAttribute('open', '');
      } else {
        // Close on mobile
        details.removeAttribute('open');
      }
    });
  }

  static init() {
    new FooterDetails();
  }
}

export default FooterDetails;
